export default {
  es: {
    categoriesDescription:
      'Selecciona una categoría y a continuación una sección para poder ver su contenido.',
    elementsDescription:
      'Selecciona uno de los siguientes materiales educativos para poder visualizarlo.',
    createCat: 'Crear categoría',
    createSec: 'Crear sección',
    categoryName: 'Nombre categoría',
    sectionName: 'Nombre sección',
    editSection: 'Editar sección',
    editCategory: 'Editar categoría',
    newSection: 'Nueva sección',
    itemCreated: 'Un nuevo ítem ha sido creado',
    itemUpdated: 'Un ítem ha sido actualizado',
    itemDeleted: 'Un ítem ha sido eliminado',
    infoMaterial: 'Información del material',
    elementType: 'Tipo de elemento',
    selecType: 'Selecciona el tipo de archivo',
    title: 'Título',
    typeTitle: 'Ingresa el título del archivo',
    stages: 'Estadíos',
    selectStages: 'Selecciona los estadíos',
    loadPrev: 'Carga y previsualización',
    click: 'Haz click o arrastra tus archivos para subirlos',
    restrictions:
      'Puedes subir uno o más archivos de no más de 4Mb en formato JPG, 6Mb en formato PDF o 2Gb en formato MP4.',
    wrong: '¡Algo salió mal!',
    wrongText:
      'El elemento que intentas cargar no cumple con los requisitos, intenta nuevamente con el formato y tamaño definidos.'
  },
  en: {
    categoriesDescription:
      'Choose a category and next pick a section to view it content.',
    elementsDescription:
      'Choose one of following educational materials to view it.',
    createCat: 'Create category',
    createSec: 'Create section',
    categoryName: 'Category name',
    sectionName: 'Section name',
    editSection: 'Edit section',
    editCategory: 'Edit category',
    newSection: 'New section',
    itemCreated: 'A new item have been created',
    itemUpdated: 'An item have been updated',
    itemDeleted: 'An item have been deleted',
    infoMaterial: '',
    elementType: 'Element type',
    selecType: 'Select element type',
    title: 'Title',
    typeTitle: 'Type file title',
    stages: 'Stages',
    selectStages: 'Select stages',
    loadPrev: 'Loading and preview',
    click: 'Click or drag your files to upload them',
    restrictions:
      'You can upload one or more files of no more than 4Mb in JPG format, 6Mb in PDF format or 2Gb in MP4 format.',
    wrong: '¡Something went wrong!',
    wrongText:
      'The item you are trying to load does not meet the requirements, please try again with the defined format and size.'
  }
};
